import { render, staticRenderFns } from "./grid-router-link.vue?vue&type=template&id=dfcb005c"
import script from "./grid-router-link.ts?vue&type=script&lang=js&external"
export * from "./grid-router-link.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports